import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

var FoundationKey;
(function(FoundationKey) {
    FoundationKey["OneSightEssilorLuxotticaFoundation"] = 'EL_ONESIGHT_FOUNDATION';
})(FoundationKey || (FoundationKey = {}));
const getFoundationKey = (value)=>{
    const entry = Object.entries(FoundationKey).find(([_, enumValue])=>enumValue === value
    );
    return entry ? entry[1] : undefined;
};
const getDonationFoundationIcon = (foundationKey)=>{
    const matchedFoundationKey = getFoundationKey(foundationKey);
    switch(matchedFoundationKey){
        case FoundationKey.OneSightEssilorLuxotticaFoundation:
            return /*#__PURE__*/ React.createElement(Icon, {
                key: "onesight",
                name: "onesight",
                viewBox: "0 0 80 30",
                width: 80,
                height: 30
            });
        default:
            return undefined;
    }
};

export { getDonationFoundationIcon };
//# sourceMappingURL=get-donation-foundation-icon.js.map
